import { CLIENT_LIST } from '../../constants';

const initialState = {
  data: [],
  loading: true,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CLIENT_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case CLIENT_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case CLIENT_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
